export enum CollectionsStoreKeys {
  Active = 'active',
  All = 'all',
}
